import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { ListBox } from 'primereact/listbox'

import Overlay from '../../../Overlay'

import { decode } from '@aytm/app/insights/dashboard/lib/sanitize'
import { isRowAveragesUid } from '@aytm/app/insights/dashboard/lib/config'

import './List.css'

const CLASS = 'insights-portal-subject-list'

const List = props => {
  const index = props.index ?? -1

  const editor = useMemo(() => props.editor || {}, [props.editor])

  const show = useMemo(
    () => index === editor.itemIndex && 'replace' === editor.type,
    [editor.itemIndex, editor.type, index]
  )

  const subject = useMemo(() => props.subject || {}, [props.subject])

  const subjects = useMemo(() => props.subjects || {}, [props.subjects])

  const options = useMemo(
    () =>
      Object.values(subjects)
        .map(v => {
          return { uid: v.uid, text: decode(v.text) }
        })
        .filter(v => !isRowAveragesUid(v.uid) && subject.uid !== v.uid),
    [subject.uid, subjects]
  )

  const onSelect = event => {
    props.onEditorChange({ action: 'apply', data: { uid: event.value } })
  }

  const onOuterClick = () => {
    if (props.onEditorChange) {
      props.onEditorChange({})
    }
  }

  const onKeyDown = event => {
    if (props.onEditorChange && 'Escape' === event.key) {
      props.onEditorChange({})
    }
  }

  return (
    <Overlay className={CLASS} show={show} onOuterClick={onOuterClick} onKeyDown={onKeyDown}>
      <ListBox
        className={`insights-portal ${CLASS}`}
        options={options}
        onChange={onSelect}
        filter
        optionValue={'uid'}
        optionLabel={'text'}
      />
    </Overlay>
  )
}

List.propTypes = {
  className: PropTypes.string,
  index: PropTypes.number,
  editor: PropTypes.object,
  subject: PropTypes.object,
  subjects: PropTypes.object,
  onEditorChange: PropTypes.func
}

export default List
